import React from 'react';

const HeaderLoggedOut = () => {

    return (
        <header className="main-header no-animation">
            <a href="https://intouchnetworks.com/" className="logo-link">
                <img src='/images/logos/logo-light.svg' alt="In Touch Networks Logo" className='logo-image' />
            </a>
        </header>
    );

};

export default HeaderLoggedOut;


// WEBPACK FOOTER //
// src/client/layouts/HeaderLoggedOut.js